import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { throwError, Observable } from 'rxjs';



import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService, AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { FanListModel } from 'lib/ng2-sapmp/src/models/user';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()

export class SignUpFiveGService {
  

  constructor(private http: HttpClient,
    private httpClientService: HttpClientService,
    private utilityService: UtilityService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  getSignupData() {
      if(sessionStorage.getItem('newFivegEnrollment')) {
          return true;
      }
      else {
          return false;
      }
  }

  sendEmail(data) {
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().fivegEnrollmentUrl, data).pipe(
      map((res: HttpResponse<any>) => {
        return res.body;
      }), catchError(this.handleError));
  }

  handleError = (error) => {
    return throwError(error);
  }
  
}
